import { useSideSheet } from '../../contexts/SideSheet';
import { SideSheetHeader } from '../SideSheet/SideSheet';
import MeetMyTeamContainer from './MeetMyTeamContainer';
import { useTranslation } from 'react-i18next';
import FocusTrap from 'focus-trap-react';

const MeetMyTeamMenu = () => {
  
  const { setSideSheetContent } = useSideSheet();
  const { t } = useTranslation();
  const toggle = () => setSideSheetContent(null);

  return (
        <FocusTrap active={true}
        focusTrapOptions={{
          clickOutsideDeactivates: true,
                        tabbableOptions: {
                            displayCheck: 'none'
                        }
                    }}>
       <div>
      <SideSheetHeader
        name={t('meetmycdkteam.title')}
        toggle={toggle}
        dataTestId="meetmyteam-tab-header"
      />
      <MeetMyTeamContainer></MeetMyTeamContainer>
      </div>
    </FocusTrap>
  );
}

export default MeetMyTeamMenu;